<template>
  <section class="features gallery" :class="section.id">
    <div ref="gHelper"></div>
    <div class="galleryDynamicCnt" v-if="section.galleryDisplayType === 'Dynamic'">
      <div class="cnt">
        <div class="galleryDynamic">
          <div class="galleryItem" :class="`s${i}`"
            v-for="(item, i) in section.items" :key="`g1${i}`">
            <div class="galleryImg" v-if="item.imageSm"
              :style="{'background-image': `url(${item.imageSm})`}"
              v-on:click="previewImg({e: $event, item, i, items: section.items})"></div>
            <div class="galleryImg noImg" v-else></div>
          </div>
        </div>
      </div>
    </div>
    <div class="galleryCnt" v-else>
      <div class="gallerySc" :style="{'margin-left': `${-gOffset}px`}">
        <div class="galleryWrapper gallery1">
          <div class="galleryItem" :class="`s${i}`"
            v-for="(item, i) in section.items.slice(0, 6)" :key="`g1${i}`">
            <div class="galleryImg" v-if="item.imageSm"
              :style="{'background-image': `url(${item.imageSm})`}"
              v-on:click="previewImg({e: $event, item, i, items: section.items})"></div>
            <div class="galleryImg noImg" v-else></div>
          </div>
        </div>
      </div>
      <div class="gallerySc" :style="{'margin-left': `${-(gOffset * 4)}px`}">
        <div class="galleryWrapper gallery2">
          <div class="galleryItem" :class="`s${i + 6}`"
            v-for="(item, i) in section.items.slice(6, 12)" :key="`g2${i}`">
            <div class="galleryImg" v-if="item.imageSm"
              :style="{'background-image': `url(${item.imageSm})`}"
              v-on:click="previewImg({e: $event, item, i, items: section.items})"></div>
            <div class="galleryImg noImg" v-else></div>
          </div>
        </div>
      </div>
      <div class="gallerySc" :style="{'margin-left': `${-gOffset}px`}"
        v-if="section.items.length > 12">
        <div class="galleryWrapper gallery3">
          <div class="galleryItem" :class="`s${i + 12}`"
            v-for="(item, i) in section.items.slice(12, 18)" :key="`g2${i}`">
            <div class="galleryImg" v-if="item.imageSm"
              :style="{'background-image': `url(${item.imageSm})`}"
              v-on:click="previewImg({e: $event, item, i, items: section.items})"></div>
            <div class="galleryImg noImg" v-else></div>
          </div>
        </div>
      </div>
    </div>
    <ImageViewer ref="imageViewer"/>
  </section>
</template>

<script>
import ImageViewer from '@/components/ImageViewer.vue';

export default {
  name: 'home',
  props: ['section'],
  components: { ImageViewer },
  data() {
    return {
      gOffset: 40,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    scrolled() {
      const factor = (window.screen.width >= 769) ? 0.4 : 0.14;
      const offsetTop = this.$refs.gHelper.getBoundingClientRect().top + window.scrollY;
      this.gOffset = -(window.scrollY - (offsetTop - 600)) * factor;
      if (this.gOffset > 40) this.gOffset = 40;
    },
    previewImg(data) {
      this.section.modalOpen = true;
      this.$refs.imageViewer.open(data, () => {
        this.section.modalOpen = false;
      });
    },
  },
  created() { document.addEventListener('scroll', this.scrolled); },
  destroyed() { document.removeEventListener('scroll', this.scrolled); },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.galleryCnt{
  overflow: hidden;
}
.galleryDynamic{
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px -20px;
  .galleryItem{
    width: 25%;
    padding: 0 10px 20px;
    box-sizing: border-box;
    .galleryImg{
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 7px;
      height: 180px;
      transition: all .3s ease;
      // cursor: pointer;
      background-color: #eee;
      &:hover{
        // transform: scale(1.06);
      }
    }
  }
}
.galleryWrapper{
  background-size: auto 100%;
  background-repeat: no-repeat;
  display: flex;
  width: 1320px;
  padding: 10px 0;
  .galleryItem{
    background-color: #eee;
    width: calc(220px - 20px);
    margin-right: 20px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    // cursor: pointer;
    transition: all .3s ease;
    height: 140px;
    &:hover{
      // transform: scale(1.04);
    }
    .galleryImg{
      background-position: center;
      background-size: cover;
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
    }
  }
  &.gallery1{
  }
  &.gallery2{
    // margin-left: calc(-44vw + 40px);
  }
}
</style>
